import { isDefined } from '@sgme/fp';
import classNames from 'classnames';
import { SolveResultWrapper } from 'components/shared/PriceNext';
import { FormattedNumber } from 'react-intl';
import { connect } from 'react-redux';
import { FormOwnProps } from 'shared/connect/connect';
import {
  getStreamingSolvingAmountInCurrencyByTabId,
  getStreamingSolvingAmountInPercentByTabId,
} from 'state/quotes/streaming/streaming.selector';
import { getDynamicQuoteState } from 'state/selectors';
import { AppState } from 'state/state.model';
import { Amount } from 'utils/streaming/quotePriceEvent';

export interface StateProps {
  percentPrice?: Amount;
  currencyPrice?: Amount;
  formHasChanged: boolean;
}

const mapStateToProps = (state: AppState, { formId }: FormOwnProps) => ({
  percentPrice: getStreamingSolvingAmountInPercentByTabId(state, formId),
  currencyPrice: getStreamingSolvingAmountInCurrencyByTabId(state, formId),
  formHasChanged: getDynamicQuoteState(state, formId) === 'Inconsistent',
});

function SolveResult({ currencyPrice, percentPrice, formHasChanged }: StateProps) {
  const solve = isDefined(percentPrice) && (
    <>
      <SolveResultWrapper strike={formHasChanged}>
        {<FormattedNumber value={percentPrice.value} minimumFractionDigits={2} />} {percentPrice.unit}
      </SolveResultWrapper>
      {isDefined(currencyPrice) && (
        <span
          className={classNames('ms-1 h3', {
            'text-decoration-line-through': formHasChanged,
          })}
        >
          ({<FormattedNumber value={currencyPrice.value} minimumFractionDigits={2} />} {currencyPrice.unit})
        </span>
      )}
    </>
  );

  return solve
    ? solve
    : isDefined(currencyPrice) && (
        <SolveResultWrapper strike={formHasChanged}>
          {<FormattedNumber value={currencyPrice.value} minimumFractionDigits={2} />} {currencyPrice.unit}
        </SolveResultWrapper>
      );
}

export const ConnectedSolveResult = connect(mapStateToProps)(SolveResult);
